import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles({
  root:{
    color: props => props.textColor,
    border: props => (props.borderColor ? '1px solid ' + props.borderColor : 'none'),
    backgroundColor: props => props.btnBackground,
    "&:hover": {
        backgroundColor: props => props.hoverColor,
        color: props => props.hoverTextColor
    },
    height: props => props.btnHeight,
    width: props => props.btnWidth,
    paddingBottom: props => props.paddingBottom
  },
  btnActive:{
    backgroundColor: props => props.activeColor,
    color: props => props.activeTextColor,
    "&:hover": {
      backgroundColor: props => props.activeColor,
      color: props => props.activeTextColor,
    },
  },
  label: {
    fontSize: props => props.btnTextSize,
    color: props => props.btnTextColor,
    textTransform : props => (props.btnTextTransform ? props.btnTextTransform : 'Uppercase'),
    justifyContent: props => props.labelAlign
  },
  icon: {
    marginRight: props => (props.iconMarginRight ? props.iconMarginRight : "25px")
  },
  iconActive: {
      color: props => props.iconActiveColor
  }
});

export default function BCLButton(props){
  const classes = useStyles(props);
  let iconClasses = props.isBidgelyIcon ? classNames(props.iconLeft, {
    [classes.iconActive]: props.isIconActive
  }): '';

  return(
    <Button
      type={props.type ? props.type : 'button'}
      display={(props.display)}
      className={ (props.isActive ? classes.btnActive : '') + ' ' + (props.cssClassName ? props.cssClassName : '') }
      variant={props.btnVariant ? props.btnVariant : 'text'}
      classes={{root: classes.root, label: classes.label}}
      onClick={props.onClick}
      disableRipple={props.disableRipple ? props.disableRipple : true}
      disabled={props.disabled ? props.disabled : false }
      >
      {props.iconLeft ? (props.isBidgelyIcon ?
          (<span className={iconClasses}></span>)
          : <Icon classes = {{ root: classes.icon }} className={props.isIconActive ? classes.iconActive : ''}>{props.iconLeft}</Icon>
        ) : ''}
      {props.btnText}
      {props.iconRight ? <Icon classes={{root: classes.icon}} className={ props.isIconActive? classes.iconActive : ''}>{props.iconRight}</Icon> : ''}
    </Button>
  )
}
